import React, { useEffect, useState, FC, useContext } from 'react';
import {
  Box,
  Button,
  createTheme,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  ThemeProvider,
  Typography,
  useTheme,
} from '@mui/material';
import { LocalTranslationContext } from '../../hooks/useLocalTranslation';
import { useTranslation } from 'react-i18next';

interface Props {
  question: any;
  step: number;
  onChange: (qid: string, val: string, i: number, p: boolean) => Promise<void>;
  value?: string;
  selectedLanguage?: string;
}

const CustomQuestionDropdown: FC<Props> = ({
  question,
  step,
  onChange,
  value,
  selectedLanguage,
}) => {
  const theme = useTheme();
  const localContext = useContext(LocalTranslationContext);
  const { t: globalT } = useTranslation();

  const currentLanguage = selectedLanguage ?? 'de-DE';

  function getTranslatedOption(idx: number) {
    return question.questionI18n?.options?.[currentLanguage]?.[idx] ?? question.options[idx].label;
  }

  return (
    <Box className="survey-custom-question survey-custom-question--dropdown">
      <FormGroup className="survey-answer-form-group">
        <FormControl
          className="survey-answer-select-control"
          size="small"
          sx={{ minWidth: '17.75rem' }}
        >
          <Select
            className="survey-answer-select"
            labelId="select-label"
            value={value}
            onChange={async (e: SelectChangeEvent) => {
              await onChange(question.questionId || '', e.target.value, step, false);
            }}
          >
            {question.options.map((option: any, index: any) => (
              <MenuItem
                className="survey-answer-select-option"
                key={index}
                value={option.label}
              >
                {getTranslatedOption(index)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </FormGroup>
    </Box>
  );
};

export default CustomQuestionDropdown;
